import * as S from './GroupList.styles'
import Header from './Header'
import List from './List'

const defaultProps = {}
const propTypes = {}

export const GroupList = props => {
  return (
    <S.Container>
      <Header title="Groups" />
      <List {...props} />
    </S.Container>
  )
}

GroupList.defaultProps = defaultProps
GroupList.propTypes = propTypes

export default GroupList
